import { ListOfFlats } from './ListOfFlats';

export type { TypeListOfFlatsProps } from './types';
export default ListOfFlats;
